import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=6cae5a6e&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cae5a6e')) {
      api.createRecord('6cae5a6e', component.options)
    } else {
      api.reload('6cae5a6e', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=6cae5a6e&", function () {
      api.rerender('6cae5a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inputs/Checkbox.vue"
export default component.exports